import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
// Data
import { register, login } from "../../redux/apiCalls"
import { CHARACTERS } from "../../data"
// Components
import Button from "../Button/Button"
// Styles
import { Container, Wrapper, Title, FormItem, StyledInput, StyledLabel, Message } from "./NoUserForm.styles"

const NoUserForm = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const language = useSelector((state) => state.environment.language)
    const [noAccount, setNoAccount] = useState(false)
    const [email, setEmail] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [isComplete, setIsComplete] = useState(false)

    const generatePassword = (length) => {
        let password = ""
        for (let i = 0; i < length; i++) {
            password += CHARACTERS.charAt(Math.floor(Math.random() * 62))
        }
        return password
    }
    const password = generatePassword(12)

    const handleChange = (e) => {
        e.preventDefault()

        setIsComplete(e.target.value.includes("@") && e.target.value.includes("."))
        setEmail(e.target.value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        const user = {
            username: email,
            email: email,
            password: password,
            type: "public",
            active: true,
            language: language
        }
        const registerResponse = await register(user, dispatch)
        if (registerResponse === "success") {
            const loginResponse = await login({ userName: email, password }, dispatch)
            if (loginResponse !== "success") {
                setErrorMessage(JSON.stringify(loginResponse))
            }
        } else {
            if (JSON.stringify(registerResponse).includes("email")) {
                setErrorMessage(t("registerPage.message.m4"))
            } else if (JSON.stringify(registerResponse).includes("username")) {
                setErrorMessage(t("registerPage.message.m5"))
            } else {
                setErrorMessage(JSON.stringify(registerResponse))
            }
        }
    }

    return (
        <Container>
            <Title>{t("noUserForm.title.t1")}</Title>
            {noAccount
                ?
                <Wrapper>
                    <FormItem>
                        <StyledLabel>{t("noUserForm.label.l1")}</StyledLabel>
                        <StyledInput type="text" onChange={handleChange} />
                    </FormItem>
                    <Button text={t("noUserForm.button.b4")} callback={handleSubmit} disabled={!isComplete} width={30} submit />
                    <Message>{errorMessage}</Message>
                </Wrapper>
                :
                <Wrapper>
                    <Button text={t("noUserForm.button.b1")} callback={() => navigate("/login")} width={20} />
                    <Button text={t("noUserForm.button.b2")} callback={() => navigate("/register")} width={20} />
                    <Button text={t("noUserForm.button.b3")} callback={() => setNoAccount(true)} width={40} />
                </Wrapper>
            }
        </Container>
    )
}

export default NoUserForm
